import { IsDefined, MaxLength } from 'class-validator';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class AirlineDataService extends DataService<typeof Model.General.Logic.ViewModels.AirlineItem, Model.General.Logic.ViewModels.AirlineItem, AirlineItem> {
    protected map(entity: Model.General.Logic.ViewModels.AirlineItem): AirlineItem {
        return new AirlineItemModel(entity);
    }

    public static make(ctx?: any): AirlineDataService {
        return new AirlineDataService(ctx, ctx => ctx.Airlines);
    }

    public add() {
        const entity = new Model.General.Logic.ViewModels.AirlineItem();
        return entity;
    }
}

export class AirlineItemModel extends EntityModel<Model.General.Logic.ViewModels.AirlineItem, AirlineItem> implements AirlineItem {
    
    @property<AirlineItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
    public id: number;

    @property<AirlineItemModel>(o => o.entity.title, (o, value) => o.entity.title = value)
    @IsDefined({ message: 'title is required' })
    @MaxLength(127, { message: 'title is to long' })
    public title: string;

    @property<AirlineItemModel>(o => o.entity.iataCode, (o, value) => o.entity.iataCode = value)
    @IsDefined({ message: 'iataCode is required' })
    @MaxLength(2, { message: 'iataCode is to long' })
    public iataCode: string;

    @property<AirlineItemModel>(o => o.entity.icaoCode, (o, value) => o.entity.icaoCode = value)
    @IsDefined({ message: 'icaoCode is required' })
    @MaxLength(3, { message: 'icaoCode is to long' })
    public icaoCode: string;

    @property<AirlineItemModel>(o => o.entity.iso3Code, (o, value) => o.entity.iso3Code = value)
    @IsDefined({ message: 'iso3Code is required' })
    @MaxLength(3, { message: 'iso3Code is to long' })
    public iso3Code: string;

    @property<AirlineItemModel>(o => o.entity.regionId, (o, value) => o.entity.regionId = value)
    public regionId?: number;
}



// WEBPACK FOOTER //
// ./src/app/general/airlines/form/airline-form.data.ts